export const APP_NAME = 'Admin Portal';

export const ROLES = {
  ADMIN: 'Admin',
  OPERATOR: 'Operator',
  VIEWER: 'Viewer',
};

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  MICROSOFT_365: '/microsoft365',
  USERS: '/users',
  USER_DETAIL: '/users/:id',
  GROUPS: '/groups',
  GROUP_DETAIL: '/groups/:id',
  LICENSES: '/licenses',
  LICENSE_ASSIGNMENT: '/license-assignment',
  AZURE_PERMISSIONS: '/azure-permissions',
  SHARED_MAILBOXES: '/shared-mailboxes',
  CONTACTS: '/contacts',
  MAILING_LISTS: '/mailing-lists',
  ONBOARDING: '/onboarding',
  OFFBOARDING: '/offboarding',
  GITHUB_LICENSES: '/github/licenses',
  TEAMVIEWER_LICENSES: '/teamviewer/users',
  TEAMVIEWER_CHANNELS: '/teamviewer/channels',
  AUTOCAD_LICENSES: '/autocad/licenses',
  TRIPLETEX_LICENSES: '/tripletex/licenses',
  TELARIS_LICENSES: '/telaris/licenses',
  ONSHAPE_LICENSES: '/onshape/licenses',
  SETTINGS: '/settings',
  UNAUTHORIZED: '/unauthorized',
};

export const PAGE_SIZE = 50;

export const ERROR_MESSAGES = {
  UNAUTHORIZED: 'You are not authorized to access this page',
  NOT_FOUND: 'The requested resource was not found',
  SERVER_ERROR: 'An error occurred. Please try again later',
  NETWORK_ERROR: 'Network error. Please check your connection',
};
